import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetReanudacionCATAByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetReanudacionCATAByUser = () => {
  const [loadingGetReanudacionCATAByUser, setLoadingGetReanudacionCATAByUser] = useState(false);
  const [successGetReanudacionCATAByUser, setSuccessGetReanudacionCATAByUser] = useState(false);
  const [errorGetReanudacionCATAByUser, setErrorGetReanudacionCATAByUser] = useState<any>(null);
  const [dataGetReanudacionCATAByUser, setDataReanudacionCATAByUser] = useState<any>(null);

  const [statusGetReanudacionCATAByUser, setStatusGetReanudacionCATAByUser] =
    useState<StatusGetReanudacionCATAByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getReanudacionCATAByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetReanudacionCATAByUser(true);
    setSuccessGetReanudacionCATAByUser(false);
    setErrorGetReanudacionCATAByUser(null);

    try {
      const res = await apirecord.getSolicitudReanudacionByUser(userId, expedienteId);

      setStatusGetReanudacionCATAByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetReanudacionCATAByUser(true);
      setDataReanudacionCATAByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetReanudacionCATAByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetReanudacionCATAByUser(err);
      console.error("Error en getReanudacionCATAByUser:", err);

      throw err;

    } finally {
      setLoadingGetReanudacionCATAByUser(false);
    }
  };

  return {
    getReanudacionCATAByUser,
    loadingGetReanudacionCATAByUser,
    successGetReanudacionCATAByUser,
    errorGetReanudacionCATAByUser,
    dataGetReanudacionCATAByUser,
    statusGetReanudacionCATAByUser
  };
};

export default useGetReanudacionCATAByUser;
